// extracted by mini-css-extract-plugin
export default {"navigation":"Header_navigation__HS+tX","header":"Header_header__Mw-YK","navBar":"Header_navBar__wLnBi","headerText":"Header_headerText__ujzgL"};